<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
    >
      <div class="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
        <router-link
          class="mb-12"
          to="/login"
        >
          <img
            alt="Logo"
            class="index__logo"
            :src="loginLogoSrc"
          >
        </router-link>
        <div
          v-if="brandingName"
          class="text-muted fw-semibold fs-6 mb-10"
        >
          {{ brandingName }}
        </div>
        <div class="index__content w-sm-500px bg-body rounded shadow-sm p-0 p-sm-10 p-lg-15 mx-0 mx-sm-auto mobile-login-form">
          <div class="text-center mb-10">
            <h1 class="text-dark mb-3">
              {{ $t('components.login.login') }}
            </h1>
          </div>
          <div class="fv-row mb-10">
            <label class="form-label fs-6 fw-bolder text-dark">{{ $t('components.login.email') }}</label>
            <input
              v-model="v.loginForm.username.$model"
              :class="{ 'custom-error': v.loginForm.username.$error, 'is-invalid': v.loginForm.username.$error }"
              class="form-control form-control-lg form-control-solid"
              name="username"
              type="text"
              @keypress.enter="login"
            >
            <div
              v-for="error of v.loginForm.username.$errors"
              :key="error.$uid"
              class="vuelidate-errors"
            >
              <p class="error-msg">
                {{ error.$message }}
              </p>
            </div>
          </div>
          <div class="fv-row mb-10">
            <label class="form-label fw-bolder text-dark fs-6 mb-0">{{ $t('components.login.password') }}</label>
            <input
              v-model="v.loginForm.password.$model"
              :class="{ 'error': v.loginForm.password.$errors.length, 'is-invalid': v.loginForm.password.$error }"
              autocomplete="off"
              class="form-control form-control-lg form-control-solid"
              name="password"
              type="password"
              @keypress.enter="login"
            >
            <div
              v-for="error of v.loginForm.password.$errors"
              :key="error.$uid"
              class="vuelidate-errors"
            >
              <p class="error-msg">
                {{ error.$message }}
              </p>
            </div>
          </div>
          <div class="text-center">
            <button
              id="kt_sign_in_submit"
              class="btn btn-lg btn-success w-100"
              @click="login()"
            >
              <span class="indicator-label">{{ $t('components.login.signIn') }}</span>
              <span class="indicator-progress">{{ $t('components.login.pleaseWait') }} <span
                class="spinner-border spinner-border-sm align-middle ms-2"
              />
              </span>
            </button>
            <p class="errors">
              {{ loginForm.error }}
            </p>
          </div>
          <locale-changer style="display: flex; justify-content: center;" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'bootstrap/scss/functions';
@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/mixins';

.index{
  &__logo{
    width: auto;
    height: 30px;

    @include media-breakpoint-down(sm) {
      width:auto;
      height: 28px;
    }
  }

  &__content{
    @include media-breakpoint-down(md) {
      width: 100% !important;
      box-shadow: none !important;
      border-radius: 0 !important;
      padding: 20px !important;
      margin: 0 !important;

      h1{
        font-size: 32px;
      }
    }

    @include media-breakpoint-only(xs) {
      padding: 15px !important;

      h1{
        font-size: 28px;
      }
    }
  }
}

@media (max-width: 768px) {
  .d-flex.flex-column.flex-root {
    min-height: 100vh;
    height: 100vh;
  }

  .d-flex.flex-center.flex-column.flex-column-fluid {
    padding: 20px !important;
    justify-content: center !important;
  }

  .index__content {
    max-width: 100% !important;
    width: 100% !important;
  }
}

@media (max-width: 480px) {
  .d-flex.flex-center.flex-column.flex-column-fluid {
    padding: 10px !important;
  }

  .form-control {
    font-size: 16px !important;
  }

  .btn {
    font-size: 16px !important;
    padding: 12px !important;
  }
}

.mobile-login-form {
  @media (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 30px 20px !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    background: white !important;
    min-height: auto !important;
  }

  @media (max-width: 480px) {
    padding: 20px 15px !important;
  }
}

/* Dodatkowe style dla parent containers */
@media (max-width: 768px) {
  .d-flex.flex-column.flex-column-fluid.bgi-position-y-bottom {
    min-height: 100vh !important;
    height: 100vh !important;
    background: #f5f8fa !important;
  }

  .p-10.pb-lg-20 {
    padding: 20px !important;
  }
}

@media (max-width: 480px) {
  .d-flex.flex-center.flex-column.flex-column-fluid.p-10.pb-lg-20 {
    padding: 15px !important;
    height: 100vh !important;
    min-height: 100vh !important;
  }

  .mb-12 {
    margin-bottom: 2rem !important;
  }
}

/* Upewnij się, że login page ma właściwą wysokość */
body.login-page {
  @media (max-width: 768px) {
    height: 100vh !important;
    overflow-x: hidden;
    overflow-y: auto;
  }
}

/* Główny kontener logowania na mobilnych */
@media (max-width: 768px) {
  .d-flex.flex-column.flex-root {
    position: relative !important;
    z-index: 1000 !important;
    width: 100vw !important;
    height: 100vh !important;
    min-height: 100vh !important;
  }
}
</style>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { axiosAuth, axiosInstance } from '@/http-common'
import {jwtDecode} from 'jwt-decode'
import Login from '@/types/Login'
import { AxiosError } from 'axios'
import { useI18n } from 'vue-i18n'
import useVuelidate from '@vuelidate/core'
import { email, minLength, required } from '@/vuelidate/i18n-validators'
import LocaleChanger from '@/components/extras/LocaleChanger.vue'
import { hasRole } from "@/utils/tools";
import { getClientBrandingLogo, getClientBrandingName } from '@/utils/client-branding'
import { isJwtTokenFormatValid } from '@/crud/getters'
import { resetWirepasStatus } from '@/stores/wirepasStore'

export default defineComponent({
  name: 'Login',
  components: { LocaleChanger },
  setup() {
    const { t } = useI18n()
    const loginLogoSrc = computed(() => getClientBrandingLogo(false) ?? require('@/assets/img/logo-1.svg'))
    const brandingName = computed(() => getClientBrandingName())

    return {
      t,
      v: useVuelidate(),
      loginLogoSrc,
      brandingName
    }
  },
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        error: ''
      } as Login
    }
  },
  methods: {
    async login() {
      const result = await this.v.$validate()
      if (result) {
        try {
          const authResponse = await axiosAuth.post(
              process.env.VUE_APP_AUTHORIZATION_SERVICE_URL + '/user/authenticate',
              {
                username: this.loginForm.username,
                password: this.loginForm.password
              }
          );

          const authToken = authResponse.data?.token
          if (!isJwtTokenFormatValid(authToken)) {
            throw new Error('Token not received');
          }

          const decodedTokenJson: any = jwtDecode(authToken)

          if (!decodedTokenJson) {
            this.loginForm.error = this.t('components.login.errors.authFailure');
          } else {
            localStorage.setItem('jwt_token', authToken);
            localStorage.setItem('username', decodedTokenJson.username!);

            // Ustawienie nagłówków dla axiosInstance
            axiosInstance.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
            axiosInstance.defaults.headers['Authorization'] = 'Bearer ' + authToken;

            // Pobieranie danych użytkownika
            const userDataResponse = await axiosInstance.post('/api/v1/user/data');
            const newAuthToken = userDataResponse.data?.token;
            if (!isJwtTokenFormatValid(newAuthToken)) {
              throw new Error('User data token not received');
            }

            const userData: any = jwtDecode(newAuthToken)

            const roles = userData.roles[0];
            localStorage.setItem('roles', roles);
            if (localStorage.getItem('jwt_token')) {
              localStorage.removeItem('jwt_token');
              localStorage.setItem('jwt_token', newAuthToken);
            }

            // Discard any cached hasWirepas check from before this session (e.g. a failed
            // pre-login attempt) so the sidebar menu and asset map re-check fresh, with the
            // real token, instead of staying stuck on a stale value until a page reload.
            resetWirepasStatus();

            let goTo = '/';
            if (hasRole('ROLE_FORMS_MOBILE')) {
              goTo = '/modules/forms'
            }

            await this.$router.push(goTo);
          }
        } catch (err) {
          const axiosError = err as AxiosError;
          if (axiosError.response?.status === 400) {
            this.loginForm.error = this.t('components.login.errors.emptyFields');
          } else if (axiosError.response?.status === 401) {
            this.loginForm.error = this.t('components.login.errors.authFailure');
          } else {
            this.loginForm.error = this.t('components.login.errors.internalError');
          }
        }
      }
    }
  },
  validations() {
    return {
      loginForm: {
        username: { required, minLength: minLength(3), email },
        password: { required, minLength: minLength(3) }
      }
    }
  },
  mounted() {
    document.body.classList.add('login-page')
  },
  unmounted() {
    document.body.classList.remove('login-page')
  }
})
</script>
